import { Component, OnInit } from '@angular/core';
import { ColumnMode, SelectionType } from "@swimlane/ngx-datatable";
import { SystemService } from '../../../shared/services/admServices/system.service';
import { Page } from './page';

declare var require
const Swal = require('sweetalert2')

@Component({
  selector: 'adm-log-component',
  templateUrl: './log-component.html',
  styleUrls: ['./log-component.scss']
})
export class logComponent implements OnInit {

  page = new Page();
  pageIn = new Page();
  eventsData: any;
  eventsSumData: any;
  eventId: any;
  es1: number;
  es2: number;
  es3: number;

  public selected: any[] = [];

  ColumnMode = ColumnMode;
  SelectionType = SelectionType;

  constructor(private systemService: SystemService) {
    this.page.pageNumber = 1;
    this.pageIn.pageNumber = 1;
    this.page.size = 20;
    this.pageIn.size = 20;

    this.retrieveEventsSummary();
  }

  ngOnInit(): void {
    this.setPage({ offset: 0 });
  }

  retrieveEventsSummary(): void {
    this.systemService.getEventsSummary()
    .subscribe(
     data => {
        this.eventsSumData = data.data;
        this.es1 = this.eventsSumData.countEventLevelInfo;
        this.es2 = this.eventsSumData.countEventLevelWarning;
        this.es3 = this.eventsSumData.countEventLevelError;
     },
     error => {
       console.log(error);
     });
  }

  setPage(pageInfo){
    this.pageIn.pageNumber = pageInfo.offset+1;

    this.systemService.getEvents(this.pageIn)
    .subscribe(
     data => {
      this.page.totalElements = data.totalRecords;
      this.page.totalPages = data.totalPages;
      this.page.pageNumber = data.pageNumber-1;
      this.eventsData = data.data;
      this.selected = [this.eventsData[0]];
      this.eventId = this.selected[0].id;
     },
     error => {
       console.log(error);
     });
  }

  updateFilter(event) {
    const val = event.target.value.toLowerCase();
  }

  onSelect({ selected }) {
    this.eventId = selected[0].id;
  }

  onDelete(){
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!"+ this.selected.length,
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.value) {
        // API
        this.systemService.deleteEvent(this.eventId).subscribe(
          data => {
            Swal.fire(
              'Deleted!',
              'Your event has been deleted.',
              'success'
            )
            this.setPage({ offset: 0 });
          },
          error => {
            console.log(error);
          });
      }
    })
  }

  onDeleteAll(){
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it ALL!'
    }).then((result) => {
      if (result.value) {
        // API
        this.systemService.deleteEvents().subscribe(
          data => {
            Swal.fire(
              'Deleted!',
              'Your system log has been cleared.',
              'success'
            )
            this.setPage({ offset: 0 });
          },
          error => {
            console.log(error);
          });
      }
    })
  }
}
